import type { MessageHandlerDeps } from '../../routing/message-handler-deps.js';
import { dispatchStartedPromptQueueRuns } from './dispatch-started-prompt-queue-runs.js';
import { handlePromptQueueCancellations } from './handle-prompt-queue-cancellations.js';
import { persistPromptQueueSnapshot } from './persist-prompt-queue-snapshot.js';
import { promptQueueSnapshotEntries } from './prompt-queue-snapshot-types.js';
import { startPromptQueueRuns } from './start-prompt-queue-runs.js';

/**
 * Apply a `prompt_queue_state` snapshot from the bridge, persist per-queue files, sync CLI state, then start at most one local run per queue.
 */
export async function applyPromptQueueStateFromServer(
  msg: { queues?: Record<string, unknown[]> },
  deps: MessageHandlerDeps,
): Promise<void> {
  const raw = msg.queues;
  if (!raw || typeof raw !== 'object') return;
  const entries = promptQueueSnapshotEntries(raw);
  await persistPromptQueueSnapshot(entries);
  await handlePromptQueueCancellations(entries, deps);
  const started = await startPromptQueueRuns(entries, deps);
  await dispatchStartedPromptQueueRuns(entries, started, deps);
}
